import React from 'react';
import PropTypes from 'prop-types';
import DotLoader from './Loader';

function Button(props) {
  return (
    <div className="btn">
      <button
        type="button"
        className={props?.classes}
        id={props?.id}
        onClick={props?.click}
        disabled={props?.disabled}
        style={{ cursor: props?.loading ? 'not-allowed' : 'pointer' }}
      >
        {props?.activeLoader ? (
          <div className="custom-loader" />
        ) : (
          props?.icon && <span className="button-icon">{props?.icon}</span>
        )}
        <span>{props?.label}</span>
        {props?.loading && (
          <DotLoader
            dotActiveColor="#FFFFFF"
            dotBlurColor="#FFFFFF4e"
          />
        )}
      </button>
    </div>
  );
}

Button.propTypes = {
  classes: PropTypes.string.isRequired,
  click: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  activeLoader: PropTypes.bool.isRequired,
  id: PropTypes.string,
  icon: PropTypes.node,
};

Button.defaultProps = {
  disabled: false,
  loading: false,
  id: null,
  icon: null,
};

export default Button;
